import { Link } from "react-router-dom";
import { motion } from "framer-motion";

const STATUS_TONE = {
  Concept: "text-bronze",
  "In development": "text-olive",
  Completed: "text-charcoal",
};

export const ProjectCard = ({ project, index = 0 }) => (
  <motion.article
    initial={{ opacity: 0, y: 32 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8% 0px" }}
    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: (index % 3) * 0.08 }}
    data-testid={`project-card-${project.slug}`}
  >
    <Link to={`/projects/${project.slug}`} className="group block">
      <div className="relative overflow-hidden aspect-[4/5] bg-limestone">
        <img
          src={project.cover}
          alt={`${project.title} — ${project.coverCaption}`}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.05]"
        />
        <span className="absolute left-4 top-4 bg-chalk/90 px-3 py-1.5 overline text-charcoal" data-testid={`project-status-${project.slug}`}>
          {project.status}
        </span>
        <span className="absolute left-4 bottom-4 text-[10px] uppercase tracking-overline text-chalk bg-charcoal/55 px-2.5 py-1 backdrop-blur-sm">
          {project.coverCaption}
        </span>
      </div>
      <div className="mt-5 flex items-baseline justify-between gap-4">
        <h3 className="font-serif text-2xl md:text-3xl font-light group-hover:text-bronze transition-colors duration-500">
          {project.title}
        </h3>
        <span className={`overline shrink-0 ${STATUS_TONE[project.status] || "text-olive"}`}>{project.year}</span>
      </div>
      <p className="mt-1 text-sm text-olive/90 font-light">
        {project.location} · {project.scope}
      </p>
    </Link>
  </motion.article>
);
